module.exports = __webpack_public_path__ + "img/close-hover.f0cc6baa.svg";